/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetProjectsListRequest, TGetProjectsListModel, IMappers, TGetProjectsListResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetProjectsListV2Response } from '../../entities/v2_entities/GetProjectsListV2Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetProjectsListModel(parameters: IGetProjectsListRequest): TGetProjectsListModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'countryside-constructors',
    pathApi: '/v2/get-projects-list/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetProjectsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetProjectsListRequest;
}

export async function fetchGetProjectsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetProjectsListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetProjectsListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetProjectsListModel(parameters),
    config,
  )) as FetchResponse<TGetProjectsListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetProjectsListV2Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetProjectsListResponse>;
}
